<template>
  <div id="tr_main">
    <werktijd-progress v-if="bezig_met_inladen"></werktijd-progress>
    <div>
      <div v-if="mogelijks_eerdere_tijdsregistraties" class="linkify" @click="prevInladen">Eerdere tijdsregistraties inladen</div>

      <div id="tr_lijst">
        <div v-for="week in weken" :key="week.omschr" class="week">
          <p class="week_omschr"><span class="d">{{ week.omschr }}</span> ({{ week.totale_tijdsduur | formatTijdsduur }})</p>
          <div v-for="dag in week.dagen" :key="dag.strDatum" class="trgroep" :data-datum="dag.strDatum">
            <router-link tag="div" class="datum" :to="'/nieuw/' + dag.strDatum">
              <div class="wd">{{ dag.jsDatum | weekdag }}</div>
              <div class="md">{{ dag.jsDatum.getDate() }}</div>
              <div class="td">{{ dag.totale_tijdsduur | formatTijdsduur }}</div>
            </router-link>
            <div class="wwvtw" v-if="wwvtw_actief">
              <v-btn flat icon :color="'#' + dag.wwvtw_kleur" v-if="dag.hasOwnProperty('wwvtw_icon')" :to="'/wwv_tw/' + dag.strDatum">
                <v-icon>{{ dag.wwvtw_icon }}</v-icon>
              </v-btn>
            </div>
            <div class="trs">
              <div v-for="tr in dag.trs" :key="tr.id">
                <div v-if="tr.hasOwnProperty('pauze')" class="pauze">{{ tr.pauze | formatTijdsduur }} pauze</div>
                <div @click="trClicked(tr.id)" :style="{ backgroundColor: '#' + tr.kleur }" :class="{'tr': true, 'gepland': tr.gepland}">
                  {{ tr.start | formatTijd }} - {{ tr.einde | formatTijd }}: {{ tr.omschr }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="next === 0" class="linkify" @click="nextInladen">Latere tijdsregistraties inladen</div>

      <div id="bottom_buttons">
        <v-btn v-if="checkin_info === ''" color="success" round @click="startButton" id="startButton" class="elevation-6">START</v-btn>
        <v-btn v-else color="error" round to="/checkout" id="stopButton" class="elevation-6"><div class="stop_command">STOP</div><div class="stop_extra">{{ checkin_info }}</div></v-btn>
        <v-btn color="info" round @click="plusButton" id="plusButton" class="elevation-6">+</v-btn>
      </div>
      <v-dialog ref="kiesDatumDialog" v-model="kiesDatumDialogTonen" persistent lazy full-width width="290px" >
        <div class="kiesDatumTitel">Tijdsregistratie toevoegen</div>
        <v-date-picker v-model="gekozenDatum" scrollable locale="nl-BE" :first-day-of-week="1">
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="kiesDatumDialogTonen = false">Annuleren</v-btn>
          <v-btn flat color="primary" @click="datumGekozen" :disabled="gekozenDatum === undefined">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapState, mapMutations } from 'vuex'
  import WerktijdProgress from './WerktijdProgress'

  export default {
    components: { WerktijdProgress },
    data: () => ({
      bezig_met_inladen: true,
      weken: [],
      wwvtw_actief: false,
      mogelijks_eerdere_tijdsregistraties: true,
      prev: 0,
      next: 0,
      kiesDatumDialogTonen: false,
      gekozenDatum: undefined,
      checkin_info: ""
    }),
    computed: mapState(['api']),
    methods: {
      ...mapMutations(['showDialog']),
      trClicked(id) {
        this.$router.push(`/tr/${id}`)
      },
      async startButton () {
        this.bezig_met_inladen = true
        let r = await this.api.post('/checkin')
        if (r.status === 200) {
          this.checkin_info = r.data.checkin_info
        } else {
          this.showDialog("Start-actie mislukt.")
          this.checkin_info = ""
        }
        this.bezig_met_inladen = false
      },
      plusButton () {
        this.gekozenDatum = undefined
        this.kiesDatumDialogTonen = true
      },
      datumGekozen () {
        this.kiesDatumDialogTonen = false
        this.$router.push(`/nieuw/${this.gekozenDatum}`)
      },
      async trs_inladen () {
        this.bezig_met_inladen = true
        let r = await this.api.get(`trs?prev=${this.prev}&next=${this.next}`)
        if (r.status === 200) {
          this.checkin_info = r.data.checkin_info
          const weken = r.data.trs_per_week
          this.wwvtw_actief = false
          for (let week of weken) {
            for (let dag of week.dagen) {
              dag.jsDatum = new Date(dag.strDatum)
              if (dag.hasOwnProperty('wwvtw_icon')) this.wwvtw_actief = true
            }
          }
          this.weken = weken
        } else {
          this.weken = []
        }
        this.bezig_met_inladen = false
      },
      async prevInladen () {
        const aantal_weken = this.weken.length
        const oldHeight = document.getElementById('tr_main').clientHeight
        this.prev += 1
        await this.trs_inladen()
        if (aantal_weken.length === this.weken.length) {
          this.mogelijks_eerdere_tijdsregistraties = false
        }
        Vue.nextTick(() => {
          window.scroll(0, document.getElementById('tr_main').clientHeight - oldHeight)
        })
      },
      nextInladen () {
        this.next = 1
        this.trs_inladen()
      },
      scrollNaarDatum (d) {
        for (let week of this.weken) {
          for (let dag of week.dagen) {
            if (dag.jsDatum >= d) {
              document.querySelector(`[data-datum='${dag.strDatum}']`).scrollIntoView({block: 'center'})
              return
            }
          }
        }
      }
    },
    async mounted () {
      this.mogelijks_eerdere_tijdsregistraties = true
      this.prev = 0
      this.next = 0
      await this.trs_inladen()
      Vue.nextTick(() => this.scrollNaarDatum(new Date().setHours(0,0,0,0)))
    }
  }
</script>

<style lang="stylus">
  #tr_main
    height: 100%
    padding: 4px 0 72px 0

  p.week_omschr
    color: gray
    margin: 8px 8px 8px 8px
    padding: 8px 0 0 8px
    border-top: solid #ddd 1px

    .d
      text-transform: uppercase
      font-weight: bold
      margin-right: 1em

  .trgroep
    display: flex

    .datum
      flex: 0 0 52px
      padding: 0 0 12px 8px

      .wd
        font-size: .8em
        font-weight: bold
        color: gray
        text-transform: uppercase
        text-align: center

      .md
        font-size: 2em
        line-height: 1em
        font-weight: bold
        color: gray
        text-align: center

      .td
        font-size: .8em
        color: gray
        text-align: center

    .wwvtw
      flex: 0 0 36px

      .v-btn
        margin: 10px 0 0 0

    .trs
      flex: 1 1 1px
      padding: 0 16px 12px 16px

      .tr
        margin: 0 0 12px 0;
        color: white;
        padding: 3px 2px 1px 6px
        border-radius: 4px

      .tr.gepland
        border: solid red 2px

      .pauze
        font-style: italic
        margin: -10px 0 2px 12px
        padding: 2px 0 0 6px
        color: gray
        border-left: solid 2px #005f7b

  .linkify
    cursor: pointer
    text-align: center
    padding: 10px 0 8px 0
    color: blue

  #bottom_buttons
    position: fixed
    bottom: 8px
    right: 8px
    z-index: 1

    .v-btn
      height: 48px
      min-width: 48px

    #stopButton .v-btn__content
      flex-direction: column

      .stop_extra
        font-size: .75rem
        text-transform: none

    #plusButton .v-btn__content
      width: 20px
      margin: 0 -10px
      font-size: 20px
      font-weight: bold

  .kiesDatumTitel
    font-size: 1rem
    font-weight: bold
    text-align: center
    padding: 10px 10px 6px 10px
    background-color: white
</style>
